// Generates and returns a unique rfc4122 version 4 compliant GUID
export function getGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function shortuid() {
    return 'xxxx-xxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getIdFriendlyName (name: string, type: string): string {
    const nameId = name.toLowerCase().replace(/\s/g, '');
    return `${type}-${nameId}`;
  };